import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import { gql, useQuery } from '@apollo/client'
import CachedIcon from 'components/material-symbol/icons/Cached'
import AccountCard from './account-card'

const GET_PGA_MEMBERSHIP = gql`
  query CoachAccount {
    currentUser {
      attributes {
        ... on Coach {
          pgaMembership {
            memberNumber
            memberClass
            memberType
            membershipStatus
            suspended
            admCertified
            certificationLevel
            pgaCoachEligible
          }
        }
      }
    }
  }
`

const membershipFields = [
  { label: 'Member Number', key: 'memberNumber' },
  { label: 'Member Class', key: 'memberClass' },
  { label: 'Member Type', key: 'memberType' },
  { label: 'Membership Status', key: 'membershipStatus' },
  { label: 'Certification Level', key: 'certificationLevel' },
  {
    label: 'ADM Certified',
    key: 'admCertified',
    format: value =>
      value === true || value === 'true'
        ? 'Yes'
        : value === false || value === 'false'
          ? 'No'
          : value,
  },
]

const formatMembershipValue = (value, format) => {
  if (format) return format(value) ?? '—'
  if (value === null || value === undefined || value === '') return '—'
  return String(value)
}

const MembershipDetails = ({ classes }) => {
  const { data, loading, error, refetch } = useQuery(GET_PGA_MEMBERSHIP)
  const pgaMembership = data?.currentUser?.attributes?.pgaMembership
  const [refreshing, setRefreshing] = React.useState(false)

  const handleRefresh = async () => {
    setRefreshing(true)
    try {
      await refetch()
    } finally {
      setRefreshing(false)
    }
  }

  if (error) return null

  return (
    <AccountCard
      title="PGA Membership"
      classes={classes}
      action={
        <Button
          className={classes.refreshButton}
          onClick={handleRefresh}
          disabled={loading || refreshing}
          startIcon={
            refreshing ? (
              <CircularProgress color="inherit" size={16} />
            ) : (
              <CachedIcon fontSize="small" />
            )
          }
        >
          Refresh
        </Button>
      }
    >
      <Typography className={classes.membershipCaption}>
        Information about your PGA Membership is used to personalize your
        experience. If any information is outdated or incorrect, click refresh.
      </Typography>
      {!loading ? (
        <Box className={classes.membershipGrid}>
          {membershipFields.map(({ label, key, format }) => (
            <Box key={key} className={classes.membershipStat}>
              <Typography className={classes.membershipStatLabel}>
                {label}
              </Typography>
              <Typography className={classes.membershipStatValue}>
                {formatMembershipValue(pgaMembership?.[key], format)}
              </Typography>
            </Box>
          ))}
        </Box>
      ) : (
        <Box display="flex" justifyContent="center" py={2}>
          <CircularProgress size={24} />
        </Box>
      )}
    </AccountCard>
  )
}

export default MembershipDetails
